 <div
    *ngIf="isLoading"
    class="text-center">
    <div class="spinner-border text-secondary mb-3 mt-1" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div *ngIf="!isLoading && archivedRosters.length === 0">
  <h5 class="text-secondary text-center mt-1">No Archived Rosters Found</h5>
</div>

<table
  mat-table
  [dataSource]="archivedRosters"
  class="mat-elevation-z8 mb-4"
  *ngIf="!isLoading && archivedRosters.length > 0">
  <ng-container matColumnDef="rosterNo">
    <th mat-header-cell *matHeaderCellDef> Roster No </th>
    <td mat-cell *matCellDef="let element">
      <button
        type="button"
        class="btn btn-link px-0"
        (click)="onViewRosterDetails(element.rosterNo)">{{element.rosterNo}}</button>
    </td>
  </ng-container>

  <ng-container matColumnDef="campusName">
    <th mat-header-cell *matHeaderCellDef> Campus Name </th>
    <td mat-cell *matCellDef="let element"> {{element.campusName}} </td>
  </ng-container>

  <ng-container matColumnDef="activity">
    <th mat-header-cell *matHeaderCellDef> Activity </th>
    <td mat-cell *matCellDef="let element"> {{element.activity}} </td>
  </ng-container>


  <ng-container matColumnDef="checkNo">
    <th mat-header-cell *matHeaderCellDef> Check No </th>
    <td mat-cell *matCellDef="let element"> {{element.checkNo}} </td>
  </ng-container>

  <ng-container matColumnDef="checkAmt">
    <th mat-header-cell *matHeaderCellDef class="text-end"> Check Amt </th>
    <td mat-cell *matCellDef="let element" class="text-end"> {{element.checkAmt | currency}} </td>
  </ng-container>

  <ng-container matColumnDef="checkDate">
    <th mat-header-cell *matHeaderCellDef> Check Date </th>
    <td mat-cell *matCellDef="let element"> {{element.checkDate | date: 'MM/dd/yyyy'}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-bg bg-gradient"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
